import { createSlice } from "@reduxjs/toolkit";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface ICommonSlice {
    error: string
}
const CommonSlice = createSlice<ICommonSlice, MapReducerPayloads<ICommonSlice, {
    setState: ICommonSlice,
    setError: string
}>>({
    name: 'commonSlice',
    initialState: {
        error: "",
    },
    reducers: {
        setState: (state, action) => action.payload,
        setError: (state, action) => {
            state.error = action.payload
        }
    }
})
export default CommonSlice;